<template>
  <auth>
    <div class="right-content" id="main-content">
      <div class="login-header">
        <div class="brand">
          <div class="img-responsive"><img src="@/assets/logo.png" alt="NCBA BEEDEE"></div> <b>{{ app }}</b>
          <small>Recover your account</small>
        </div>
        <div class="icon">
          <i class="fa fa-sign-in"></i>
        </div>
      </div>
      <hr>
      <div
          v-if="step===1"
          class="auth"
      >
        <form
            class="margin-bottom-0"
            @submit.prevent="recover"
        >
          <div v-html="$error.handle(error)"/>
          <div class="form-group">
            <label for="username">Email</label>
            <input
                id="username"
                v-model="user.email"
                class="form-control"
                autocomplete="email"
                required
                type="text"
            >
          </div>
          <div class="login-buttons">
            <button class="btn btn-lg btn-block btn-primary">
              Send Recovery Email
            </button>
          </div>
          <div class="m-t-20 m-b-40 p-b-40 text-inverse">
            <router-link
                :to="{name: 'Login'}"
                class="link"
            >
              Have an account? Log In
            </router-link>
          </div>
        </form>
      </div>
      <div v-if="step === 2" class="m-t-20 m-b-40 p-b-40 text-inverse">
        <div class="alert alert-info">
          <h4>Email Sent.</h4>
          <p>
            We have sent an email to {{ user.email }}. Click on the link on the email to
            recover your account.
          </p>
        </div>
      </div>
      <p class="text-center text-grey-darker">
        &copy; {{ app }} All Right Reserved 2021
      </p>
    </div>
  </auth>
</template>

<script>
import Auth from "@/components/Auth.vue";

export default {
  components: {
    Auth
  },
  data() {
    return {
      app: process.env.VUE_APP_NAME,
      user: {
        email: '',
      },
      error: '',
      step: 1
    }
  },

  methods: {
    recover() {
      this.$axios.post('/api/password-reset-email', this.user).then(() => {
        this.step = 2
      }).catch(error => {
        this.error = error.response;
      });
    }
  }
}
</script>